import { filterHtmlTags } from '@framework/data-helpers/string/filterHtmlTags';
import { SEARCH_MAX_LENGTH, SEARCH_MIN_LENGTH } from '@/creditflowresearch/ui/common/constants';

export const getTrimmedString = (
  value: string,
  maxLength: number = SEARCH_MAX_LENGTH,
  minLength: number = SEARCH_MIN_LENGTH,
): string | null => {
  const trimmedString = filterHtmlTags(value)
    .trim()
    .slice(0, maxLength);

  if (trimmedString.length < minLength && trimmedString.length > 0) return null;

  return trimmedString;
};
